<a class="calendar__print calendar__icon-link"  (click)="export()">
    <div class="calendar__icon-wrapper">
      <mat-icon svgIcon="download"></mat-icon>
    </div>
    Add to Calendar
</a>
